module.exports = __webpack_public_path__ + "img/trello-logo-blue.7511b4c5.svg";